import type {
    Counter,
    Histogram,
    PrometheusMetric,
    PrometheusMetrics,
} from './prometheus.interfaces';
import { buildCounter, buildHistogram, renderMany } from './prometheus.functions';

export const NOOP = () => {};

function buildMetrics(
    baseName: string,
    gatewayUrl: string,
    reportError: (error: Error) => void = NOOP
): PrometheusMetrics {
    const requestQueue: Promise<unknown>[] = [];

    const flush = async (): Promise<void> => {
        await Promise.all(requestQueue);
        requestQueue.length = 0;
    };

    const renderAndPush = (metrics: PrometheusMetric | PrometheusMetric[]): void => {
        const metricsArray = Array.isArray(metrics) ? metrics : [metrics];
        const body = renderMany(metricsArray);

        const request: Promise<unknown> = fetch(`${gatewayUrl}`, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'text/plain; charset=utf-8' },
            body,
        })
            .catch((error) => reportError(error))
            .finally(flush);

        requestQueue.push(request);
    };

    return {
        getCounter: (name: string): Counter => {
            const sanitizedName = `${baseName}_${name}_total`;

            return buildCounter(sanitizedName, renderAndPush);
        },
        getHistogram: (name: string, buckets: number[]): Histogram => {
            const sanitizedName = `${baseName}_${name}`;

            return buildHistogram(sanitizedName, buckets, renderAndPush);
        },
    };
}

function setupPrometheus() {
    return buildMetrics(
        'site_neo',
        import.meta.env.VITE_PROMETHEUS_GATEWAY ?? 'http://localhost:8888',
        (error) => {
            console.log('Metrics', 'Error', { error });
        }
    );
}

export const prometheus = setupPrometheus();
